import { render, staticRenderFns } from "./HostingKvmRdns.vue?vue&type=template&id=66bab1e8&scoped=true&"
import script from "./HostingKvmRdns.vue?vue&type=script&lang=js&"
export * from "./HostingKvmRdns.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmRdns.vue?vue&type=style&index=0&id=66bab1e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bab1e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66bab1e8')) {
      api.createRecord('66bab1e8', component.options)
    } else {
      api.reload('66bab1e8', component.options)
    }
    module.hot.accept("./HostingKvmRdns.vue?vue&type=template&id=66bab1e8&scoped=true&", function () {
      api.rerender('66bab1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmRdns.vue"
export default component.exports